import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

export default function FeedbackEmotionalAwarenessPage() {
  const { t } = useTranslation()
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      <div className="flex h-full flex-col text-center">
        <div className="flex grow flex-col items-center justify-center px-4">
          <div className="mb-4 flex items-center gap-2 rounded-full bg-purple-100 px-4 py-2">
            <span className="text-sm font-medium text-purple-700">
              {t('pages.onboarding.feedbackEmotionalAwareness.badge')}
            </span>
          </div>

          <h1 className="custom-heading mb-4 text-2xl leading-tight">
            {t('pages.onboarding.feedbackEmotionalAwareness.title')}
          </h1>

          <p className="mb-6 max-w-sm leading-relaxed text-gray-600">
            {t('pages.onboarding.feedbackEmotionalAwareness.description')}
          </p>

          <div className="grid w-full max-w-sm grid-cols-2 gap-4">
            <div className="rounded-2xl bg-gradient-to-br from-green-50 to-green-100 p-4">
              <p className="text-3xl font-bold text-green-600">58%</p>
              <p className="mt-1 text-xs text-gray-600">
                {t('pages.onboarding.feedbackEmotionalAwareness.stat1')}
              </p>
            </div>
            <div className="rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 p-4">
              <p className="text-3xl font-bold text-blue-600">3x</p>
              <p className="mt-1 text-xs text-gray-600">
                {t('pages.onboarding.feedbackEmotionalAwareness.stat2')}
              </p>
            </div>
          </div>

          <p className="mt-6 max-w-sm text-xs text-gray-400 italic">
            {t('pages.onboarding.feedbackEmotionalAwareness.source')}
          </p>
        </div>

        <Form className="shrink-0" method="post" onSubmit={handleSubmit}>
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue"
          />
        </Form>
      </div>
    </Layout>
  )
}
